import React from 'react'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
import { withModal } from '@brainstud/react-tbl/features/modals'

import Cols from './Cols'
import Rows from './Rows'
import Map from './Map'
import NoTemplate from './NoTemplate'

const lessonTypes = {
  cols: Cols,
  rows: Rows,
  exercise: Rows,
  map: Map,
}

export const ContentType = props => {
  const Type = lessonTypes[props.type || 'rows']
  if(!Type) return null

  return <Type {...props} />
}

const Template = props => {
  const Chapter = props.app.templates.chapters[props.chapter.id]
  if(!Chapter) return <NoTemplate {...props} />

  const Lesson = Chapter[props.lesson.id]
  if(!Lesson) return <NoTemplate {...props} />

  return <Lesson {...props} />
}

export const CurrentTemplate = withApp(withModal(Template))
